import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoDeleteRequestDTO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly data: RoomBrandLogoDeleteRequest) {
    JsonSchemaValidator.assert(RoomBrandLogoDeleteRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoDeleteRequest {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
